import { rootWrapper } from "./root-wrapper";

export const wrapPageElement = rootWrapper;